import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  ssccWrapper: {
    display: "flex",
    flex: 1,
    flexGrow: 1,
    padding: "24px",
    border: "1px solid #E4E7EC",
    borderRadius: 8,
  },
  sectionTitle: {
    marginBottom: 20,
    color: "#465869",
    fontSize: 16,
    fontFamily: "'Manrope', sans-serif",
    lineHeight: "18px",
    fontWeight: "bold",
  },
  ssccFooter: {
    paddingTop: "auto",
  },
  button: {
    fontWeight: 700,
    fontFamily: "Inter",
  },
}));

export const SSCCGenerationInputLabel = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  color: "#308CDB",
}));

export const SSCCGenerationSwitchWRapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: 0.5,
  },
}));

export default styles;
